<div class="signup-container">
    <div class="wrapper">
        <section>
            <div class="signup-title">Sign Up</div>
            <div class="form-switch">
                <button class="form-switch-btn" 
                        mat-mini-fab color="accent"
                        aria-label="toggle first form"
                        (click)="showSecondaryForm=false;showPersonForm = true;" >
                    1
                </button>
                <button class="form-switch-btn"
                        mat-mini-fab color="accent"
                        aria-label="toggle second form" 
                        [disabled]="!showSecondaryForm">
                    2
                </button>
            </div>
            <!-- First Form to get PERSONAL- DETAILS -->
            <form class="details-form" [formGroup]="basicInfoForm" (ngSubmit)="onBasicInfoSubmit()" *ngIf="showPersonForm">
            <p class="details-form-title">Please enter your Personal Details</p>
                <div class="details-form-container">
                    <mat-form-field class="details-form-input" appearance="outline">
                        <mat-label>First Name</mat-label>
                        <input matInput
                            type="text" 
                            name="firstName"
                            formControlName = "firstName">
                            <mat-error *ngIf="basicInfoForm.controls.firstName.hasError('required')">
                                First Name is <strong>required</strong>
                            </mat-error>
                    </mat-form-field>
                    <mat-form-field class="details-form-input" appearance="outline">
                        <mat-label>Last Name</mat-label>
                        <input matInput
                            type="text" 
                            name="lastName"
                            formControlName = "lastName">
                            <mat-error *ngIf="basicInfoForm.controls.lastName.hasError('required')">
                                Last Name is <strong>required</strong>
                            </mat-error>
                    </mat-form-field>
                    <mat-form-field class="details-form-input" appearance="outline">
                        <mat-label>Middle Name</mat-label>
                        <input matInput
                            type="text" 
                            name="middleName"
                            formControlName = "middleName">
                    </mat-form-field>
                    
                    <button type="submit" 
                            class="details-form-next-btn" 
                            mat-mini-fab color="primary"
                            [disabled]="!basicInfoForm.valid && basicInfoForm.touched"
                            aria-label="navigate next">
                        <mat-icon>arrow_forward</mat-icon>
                    </button>
                </div>
            </form>

            <!-- Second Form to get SECONDARY- DETAILS -->
            <form class="details-form" [formGroup]="secondaryDetailsForm" (ngSubmit)="onSecondaryFormSubmit()" *ngIf="showSecondaryForm">
                <p class="details-form-title">Please enter your Secondary Details</p>
                <div class="details-form-container">
                    <mat-form-field class="details-form-input" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput
                                type="email" 
                                name="email"
                                formControlName = "email">
                            <mat-error *ngIf="secondaryDetailsForm.controls.email.hasError('required')">
                                Email is <strong>required</strong>
                            </mat-error>
                            <mat-error *ngIf="secondaryDetailsForm.controls.email.hasError('email')">
                                Enter a correct <strong>Email</strong>
                            </mat-error>
                    </mat-form-field>
                    <mat-form-field class="details-form-input" appearance="outline">
                        <mat-label>Password</mat-label>
                        <input matInput
                                type="password" 
                                name="password"
                                formControlName = "password">
                            <mat-error *ngIf="secondaryDetailsForm.controls.password.hasError('required')">
                                Password is <strong>required</strong>
                            </mat-error>
                            <mat-error *ngIf="secondaryDetailsForm.controls.password.hasError('minlength')">
                                Password should be <strong>min 8 characters</strong>
                            </mat-error>
                            <mat-error *ngIf="secondaryDetailsForm.controls.password.hasError('pattern')">
                                Password should be <strong>one caps,one small,one numeric,one special charecter is required</strong>
                            </mat-error>
                    </mat-form-field>
                    <mat-form-field class="details-form-input" appearance="outline">
                        <mat-label>Confirm Password</mat-label>
                        <input matInput
                                type="password" 
                                name="confirm-password"
                                formControlName = "confirmPassword">
                            <mat-error *ngIf="secondaryDetailsForm.controls.confirmPassword.hasError('required')">
                                Confirm Password is <strong>required</strong>
                            </mat-error>
                            <mat-error *ngIf="secondaryDetailsForm.controls.confirmPassword.hasError('minlength')">
                                Confirm Password should be <strong>min 8 characters</strong>
                            </mat-error>
                    </mat-form-field>

                    <p class="hasError" *ngIf="errorMessage">{{errorMessage}}</p>
                </div>
                <button class="details-form-btn" type="submit"  
                            [disabled]="!secondaryDetailsForm.valid && secondaryDetailsForm.touched">
                            Create my account</button>
            </form>
        
        </section>
        <!-- <section class="signup-success" *ngIf="signupSuccess">
            Congratulations! You have successfully created the user account.
        </section> -->
         <div class="signup" >
            Already have an account? <span class="signup-link" [routerLink]="[ '/user/login']">Login</span>
        </div> 
    </div>
</div>